"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSharedService = void 0;
const context_1 = require("./context");
const react_1 = require("react");
function useSharedService(service) {
    const context = context_1.useSharedValueStoreContext();
    return react_1.useMemo(() => context.service(service), [context]);
}
exports.useSharedService = useSharedService;
//# sourceMappingURL=use-shared-service.js.map